import { Icon, IconButton } from '@mui/material';
import React from 'react';
import { FlexGridRow } from 'global/components/flex-grid-list';
import { InlineModal } from 'global/components/room-select/styles';
import { Row } from 'global/components/row';
import { Text } from 'global/components/text';

/**
 * Shared location row for assignment modals: primary label, count, edit / copy access / paste access actions.
 * Parents own data, clipboard state, and persistence; this component handles layout and control wiring only.
 */
export function AssignmentLocationRow({
  locationId,
  name,
  countLabel,
  copiedLocationAccess,
  onPreview,
  onCopyLocationAccess,
  onPasteLocationAccess,
  previewDisabled = false,
  copyDisabled = false,
  rowDimmed = false,
  titlePreview,
  titleCopy,
  titlePaste,
}) {
  const pasteDisabled =
    !copiedLocationAccess || String(copiedLocationAccess.id) === String(locationId);

  return (
    <FlexGridRow dimmed={rowDimmed}>
      <Row style={{ alignItems: 'center' }}>
        <Text type="label_large">{name}</Text>
        <Row style={{ marginLeft: 'auto', alignItems: 'center' }}>
          <Text type="label_large" style={{ marginRight: 12 }}>
            {countLabel}
          </Text>
          <InlineModal style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton color="secondary" disabled={previewDisabled} onClick={onPreview} title={titlePreview}>
              <Icon>edit_outlined</Icon>
            </IconButton>
            <IconButton color="secondary" disabled={copyDisabled} onClick={onCopyLocationAccess} title={titleCopy}>
              <Icon>file_copy_outlined</Icon>
            </IconButton>
            <IconButton color="secondary" disabled={pasteDisabled} onClick={onPasteLocationAccess} title={titlePaste}>
              <Icon>post_add_oulined</Icon>
            </IconButton>
          </InlineModal>
        </Row>
      </Row>
    </FlexGridRow>
  );
}
